<template>
  <div class="priceCreated">
    <!-- 创建起点-公有云和数据中心 -->
    <el-dialog
      :title="diglog.dialogText"
      :visible.sync="diglog.centerDialogVisible"
      :width="diglog.dialogStatus ? '500px' : '41%'"
      center
      :destroy-on-close="true"
    >
      <div
        class="dialog"
        v-show="diglog.dialogStatus"
      >
        <div
          class="tl"
          @click="cloudTap"
        >
          <div class="start">
            <img
              src="../../assets/img/price/cloudstart.png"
              alt=""
            />
          </div>
          <div>{{$t('pricedialog.cloudtitle')}}</div>
        </div>
        <div
          class="tl"
          @click="dataTap"
        >
          <div class="end">
            <img
              src="../../assets/img/price/datastart.png"
              alt=""
            />
          </div>
          <div>{{$t('pricedialog.datatitle')}}</div>
        </div>
      </div>
      <!-- 公有云 -->
      <div
        class="cloud"
        v-show="diglog.cloudStatus"
      >
        <el-form
          :label-position="labelPosition"
          :label-width="this.$i18n.locale=='en'?'120px':'80px'"
          :model="formLabelAlign"
        >
          <el-form-item :label="$t('pricedialog.cloudtype')">
            <el-select
              v-model="formLabelAlign.value"
              @change="cloudListTap(formLabelAlign.value)"
              :placeholder="$t('checkvalid.select')"
            >
              <el-option
                v-for="item in optioncloud"
                :key="item.name"
                :label="$i18n.locale=='en'?item.en_name:item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <div style="width:100%;display:flex; justify-content: space-between;margin-top:10px;">
              <div class="titlehead">
                {{$t('pricedialog.country')}}
              </div>
              <div class="titlehead">
                {{$t('pricedialog.city')}}
              </div>
              <div class="titlehead">
                {{$t('pricedialog.dataheader')}}
              </div>
            </div>
            <div style="width:100%;display:flex; justify-content: space-between;">
              <ul class="widsty">
                <li
                  v-for="(item, index) in country"
                  :key="index"
                  class="country"
                  :class="item.name==select? 'active' : item.en_name==select?'active':''"
                  @click="countryTap(item)"
                >
                
                  {{ $i18n.locale=='en'?item.en_name:item.name }}
                </li>
              </ul>
              <ul class="widsty">
                <li
                  v-for="(item, im) in city"
                  :key="im"
                  class="city"
                  @click="cityTap(item)"
                  :class="item.name==selectcity ? 'active' :item.en_name==selectcity?'active': ''"
                >
                 {{ $i18n.locale=='en'?item.en_name:item.name }}
                </li>
              </ul>
              <ul class="widsty">
                <li
                  v-for="(item, ic) in poplist"
                  :key="ic"
                  class="poplist"
                  :class="selectpop == item.name ? 'active' :selectpop==item.en_name?'active': ''"
                  @click="popTap(item)"
                >
                <span  v-if="$i18n.locale=='en'" :title="item.en_name">
                   {{ item.en_name | popellipsis}}
                </span>
                <span v-else>
                   {{ item.name}}
                </span>
                </li>
              </ul>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button @click="backTap">{{$t('pricedialog.back')}}</el-button>
            <el-button
              type="success"
              @click="submit"
            >{{$t('pricedialog.success')}}</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 数据中心 -->
      <div
        class="cloud"
        v-show="diglog.dataStatus"
      >
        <el-form
          :label-position="labelPosition"
          label-width="80px"
          :model="formLabelAlignData"
        >
          <el-form-item>
            <div style="width:100%;display:flex; justify-content: space-between;">
              <div class="titlehead">
                 {{$t('pricedialog.country')}}
              </div>
              <div class="titlehead">
                 {{$t('pricedialog.city')}}
              </div>
              <div class="titlehead">
                 {{$t('pricedialog.dataheader')}}
              </div>
            </div>
            <div style="width:100%;display:flex; justify-content: space-between;">
              <ul class="widsty">
                <li
                  v-for="(item, index) in country"
                  :key="index"
                  class="country"
                  :class=" item.name ==selects ? 'active' :item.en_name?'active': ''"
                  @click="countryTapData(item)"
                >
                   {{ $i18n.locale=='en'?item.en_name:item.name }}
                </li>
              </ul>
              <ul class="widsty">
                <li
                  v-for="(item, im) in city"
                  :key="im"
                  class="city"
                  :class="selectcitys == item.name ? 'active' :selectcitys==item.en_name?'active': ''"
                  @click="cityTapData(item)"
                >
                  {{ $i18n.locale=='en'?item.en_name:item.name }}
                </li>
              </ul>
              <ul class="widsty">
                <li
                  v-for="(item, ic) in poplistData"
                  :key="ic"
                  class="poplist"
                  :class="selectpops == item.name ? 'active' :selectpops==item.en_name?'active': ''"
                  @click="popTapData(item)"
                >
                <span  v-if="$i18n.locale=='en'" :title="item.en_name">
                   {{ item.en_name | popellipsis}}
                </span>
                <span  v-else>
                   {{ item.name}}
                </span>
                </li>
              </ul>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button @click="backTaps">{{$t('pricedialog.back')}}</el-button>
            <el-button
              type="success"
              @click="submits"
            >{{$t('pricedialog.success')}}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    diglog: Object,
    optioncloud: Array,
    packtext: String
  },
  data() {
    return {
      formLabelAlign: {
        value: "1"
      },
      // 二级
      labelPosition: "left",
      formLabelAlignData: {},
      allData: {},
      names: "",
      nation: "",
      citys: "",
      country: [], //国家
      contryid: "1",
      city: [],
      cityid: "",
      poplist: [],
      popid: "",
      poplistData: [],
      popDataid: "",
      select: "中国",
      selectcity: "",
      selectpop: "",
      selects: "中国",
      selectcitys: "",
      selectpops: ""
    };
  },
  created() {
    this.getcountry();
    this.getcity();
    this.getpop();
    this.getpopData();
  },
  methods: {
    // 国家
    getcountry() {
      const data = {
        token: this.$store.state.token,
        search_cloud: this.formLabelAlign.value
      };
      this.$http
        .post("/price/get_country", data)
        .then(res => {
          console.log(res);
          if (res.status == 200) {
            if (res.data.status == 0) {
              // 先进行本地存储
              this.country = res.data.data.items;
              this.select = this.$i18n.locale=='en'?"China":"中国";
              this.contryid = "1";
              this.selects = this.$i18n.locale=='en'?"China":"中国";
              console.log(res.data);
            } else {
              this.$message({
                message: res.data.error,
                type: "warning",
                duration: 1500
              });
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 城市
    getcity() {
      const data = {
        token: this.$store.state.token,
        search_country: this.contryid,
        search_cloud: this.formLabelAlign.value
      };
      this.$http
        .post("/price/get_city", data)
        .then(res => {
          console.log(res);
          if (res.status == 200) {
            if (res.data.status == 0) {
              // 先进行本地存储
              this.city = res.data.data.items;
            } else {
              this.$message({
                message: res.data.error,
                type: "warning",
                duration: 1500
              });
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 云数据中心
    getpop() {
      const data = {
        token: this.$store.state.token,
        search_city: this.cityid,
        search_country: this.contryid,
        search_cloud: this.formLabelAlign.value
      };
      this.$http
        .post("/price/get_pop", data)
        .then(res => {
          console.log(res);
          if (res.status == 200) {
            if (res.data.status == 0) {
              this.poplist = res.data.data.items;
            } else {
              this.$message({
                message: res.data.error,
                type: "warning",
                duration: 1500
              });
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 数据中心
    getpopData() {
      const data = {
        token: this.$store.state.token,
        search_city: this.cityid,
        search_country: this.contryid,
        search_type: "dc"
      };
      this.$http
        .post("/price/get_pop", data)
        .then(res => {
          console.log(res);
          if (res.status == 200) {
            if (res.data.status == 0) {
              // 先进行本地存储
              this.poplistData = res.data.data.items;
              console.log(this.poplistData);
            } else {
              this.$message({
                message: res.data.error,
                type: "warning",
                duration: 1500
              });
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    countryTap(item) {
      if(this.$i18n.locale=='en') {
         this.select = item.en_name;
      }else {
         this.select = item.name;
      }
      this.contryid = item.id;
      this.getcity();
      this.getpop();
    },
    cityTap(item) {
      if(this.$i18n.locale=='en') {
         this.selectcity = item.en_name;
      }else {
         this.selectcity = item.name;
      }
      this.cityid = item.id; //城市id
      this.getpop();
    },
    popTap(item) {
      if(this.$i18n.locale=='en') {
        this.selectpop = item.en_name;
      }else {
        this.selectpop = item.name;
      }
      this.popid = item.id;
    },
    countryTapData(item) {
      if(this.$i18n.locale=='en') {
        this.selects = item.en_name;
      }else {
         this.selects = item.name;
      }
      this.contryid = item.id;
      this.getcity();
      this.getpopData();
    },
    cityTapData(item) {
      if(this.$i18n.locale=='en') {
         this.selectcitys = item.en_name;
      }else {
        this.selectcitys = item.name;
      }
      this.cityid = item.id; //城市id
      this.getpopData();
    },
    popTapData(item) {
      if(this.$i18n.locale=='en') {
        this.selectpops = item.en_name;
      }else {
        this.selectpops = item.name;
      }
      this.popDataid = item.id;
      console.log(this.popDataid);
    },
    //云端起点
    cloudTap() {
      this.diglog.dialogText = this.$t('checkvalid.dialogText');
      this.diglog.dialogStatus = false;
      this.diglog.cloudStatus = true;
      this.select = "";
      this.selectcity = "";
      this.selectpop = "";
      this.formLabelAlign.value = "1";
      this.contryid = "";
      this.cityid = "";
      this.selects = "";
      this.selectcitys = "";
      this.selectpops = "";
      // 新添加
      this.city = [];
      this.poplist = [];
      this.getcountry();
      this.getcity();
      this.getpop();
    },
    // 云类型
    cloudListTap(value) {
      console.log(value);
      this.getcountry();
      this.getcity();
      this.getpop();
    },
    submit() {
      console.log(this.contryid);
      if (!this.cityid) {
        console.log(3333);
        this.$message({
          message: this.$t('checkvalid.selectcity'),
          type: "warning",
          duration: 1500
        });
        return;
      }
      if (!this.popid) {
        console.log(3333);
        this.$message({
          message: this.$t('checkvalid.selectdata'),
          type: "warning",
          duration: 1500
        });
        return;
      }

      this.$emit(
        "func",
        JSON.stringify(this.selectpop),
        this.select,
        this.selectcity,
        this.popid,
        this.cityid,
        this.formLabelAlign.value
      );
      this.diao();
      this.diglog.centerDialogVisible = false;
      console.log(this.selectpop);
      if (this.packtext) {
        this.$parent.tapclick();
      }
    },
    backTap() {
      this.diglog.cloudStatus = false;
      this.diglog.dialogStatus = true;
      this.diglog.dialogText = this.$t('pricedialog.dialogTextStart');
    },
    selectedChange(value) {
      console.log(value);
    },
    // 数据中心
    dataTap() {
      this.diglog.dialogText = this.$t('checkvalid.dc');
      this.diglog.dialogStatus = false;
      this.diglog.dataStatus = true;
      this.select = "";
      this.selectcity = "";
      this.selectpop = "";
      this.formLabelAlign.value = "";
      this.contryid = "";
      this.cityid = "";
      this.selects = "";
      this.selectcitys = "";
      this.selectpops = "";
      // 添加
      this.city = [];
      this.poplistData = [];

      this.getcountry();
      this.getcity();
      this.getpopData();
    },
    backTaps() {
      this.diglog.dialogStatus = true;
      this.diglog.dataStatus = false;
      this.diglog.dialogText = this.$t('pricedialog.dialogTextStart');
    },
    submits() {
      if (!this.cityid) {
        console.log(3333);
        this.$message({
          message: this.$t('pricedialog.selectcity'),
          type: "warning",
          duration: 1500
        });
        return;
      }
      if (!this.popDataid) {
        this.$message({
          message: this.$t('pricedialog.selectdata'),
          type: "warning",
          duration: 1500
        });
        return;
      }
      this.$emit(
        "func",
        JSON.stringify(this.selectpops),
        this.selects,
        this.selectcitys,
        this.popDataid,
        this.cityid
      );
      this.diao();
      this.diglog.centerDialogVisible = false;
      if (this.packtext) {
        this.$parent.tapclick();
      }
    },
    diao() {
      this.$parent.datanewmap();
    }
  }
};
</script>
<style lang="scss">
.priceCreated {
  .el-form--label-left .el-form-item__label {
    text-align: left;
    color: #1d5a33;
    font-size: 16px;
  }
  .el-form-item__label {
    padding: 0;
  }
  .el-form-item__content {
    margin-left: 0 !important;
  }

  .el-cascader-node:not(.is-disabled):focus,
  .el-cascader-node:not(.is-disabled):hover {
    background: none !important;
  }
  .el-form-item {
    margin-bottom: 15px !important;
  }
  .el-cascader-node__postfix {
    display: none;
  }

  .widsty {
    width: 28%;
    height: 230px;
    text-align: center;
    overflow: auto;
    margin-bottom: 14px;
    border: solid 1px #1d5a33;
    border-top: 0;
    li {
      width: 100%;
      cursor: pointer;
      height: 26px;
      line-height: 26px;
    }
    .country.active {
      background: url("../../assets/img/price/select.png") no-repeat center
        center;
      background-size: 100% 100%;
      color: #fff;
    }
    .city.active {
      background: url("../../assets/img/price/select.png") no-repeat center
        center;
      background-size: 100% 100%;
      color: #fff;
    }
    .poplist.active {
      background: url("../../assets/img/price/select.png") no-repeat center
        center;
      background-size: 100% 100%;
      color: #fff;
    }
  }
}
</style>
